import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { ORANGE } from '../../../shared/colors';
import { Header } from './header';

const Container = styled.div`
  background: var(--mt-primary);
  max-width: 100%;
  overflow-x: hidden;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  .marquee-rtl {
    background: linear-gradient(90deg, #041018, #071f2a, #041018);
    overflow: hidden;
    padding: 0;
  }

  .marquee-bg {
    background: rgba(4, 16, 24, 0.94);
    overflow: hidden;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }

  .marquee-text {
    color: rgba(248, 250, 252, 0.88);
    display: inline-block; /* modèle de boîte en ligne */
    font-family: Poppins-R;
    font-size: 11.5px;
    line-height: 1.8;
    padding-right: 2em; /* un peu d'espace pour la transition */
    padding-left: 100%; /* placement à droite du conteneur */
    white-space: nowrap; /* pas de passage à la ligne */
    animation: defilement-rtl 60s infinite linear;
  }

  .marquee-text b {
    font-family: Poppins-R;
    font-weight: 500;
  }

  .marquee-text span {
    color: var(--mt-warning) !important;
    font-family: Poppins-B;
  }
  @keyframes defilement-rtl {
    0% {
      transform: translate3d(0, 0, 0); /* position initiale à droite */
    }
    100% {
      transform: translate3d(-100%, 0, 0); /* position finale à gauche */
    }
  }
`;

export const Layout = ({
  children,
  other,
  hideYellowScrollInfo,
}: {
  children: ReactNode;
  other?: ReactNode;
  hideYellowScrollInfo?: boolean;
}) => {
  return (
    <div style={{ maxWidth: '100%', overflowX: 'hidden' }}>
      <Header other={other} />
      {/* <>{other}</> */}
      {!hideYellowScrollInfo && (
        <Container>
          <div
            className='marquee-rtl'
          >
            <div className='marquee-bg'>
              <div className='marquee-text'>
                <b>
                  ACTION REGIONALE : &nbsp;
                  <span style={{ color: ORANGE }}>42500 FCFA</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ACTION BANGE : &nbsp;
                  <span style={{ color: ORANGE }}>207110 FCFA</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ACTIONS SCG-Ré : &nbsp;
                  <span style={{ color: ORANGE }}>21000 FCFA</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ACTION SAFACAM : &nbsp;
                  <span style={{ color: ORANGE }}> 26000 FCFA</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  EOG 07 22/28 : &nbsp;
                  <span style={{ color: ORANGE }}>100,00 %</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  BDEAC 03 22/29 :&nbsp;
                  <span style={{ color: ORANGE }}> 100,00 %</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ECMR.06 22/29 : &nbsp;
                  <span style={{ color: ORANGE }}>96 %</span> (0,000 %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  BDEAC 02 21/28 :&nbsp;
                  <span style={{ color: ORANGE }}> 100 % </span> (0,000 %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ALIOS.02 21/25 : &nbsp;
                  <span style={{ color: ORANGE }}>100,00 % </span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  EOG.06 21-26 :&nbsp;
                  <span style={{ color: ORANGE }}>99.50 % </span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  EOCG.02-21/26 :&nbsp;
                  <span style={{ color: ORANGE }}> 95,00 % </span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  EOTD01 22/27 :&nbsp;
                  <span style={{ color: ORANGE }}> 100,00 % </span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  EOBDE01 20/27 :&nbsp;
                  <span style={{ color: ORANGE }}> 99,99 %</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  EOG.05 19/24 :&nbsp;
                  <span style={{ color: ORANGE }}> 99,00 </span> (0,000 %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ECMR.05-18/23 :&nbsp;
                  <span style={{ color: ORANGE }}> 99,20 % </span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ALIOS.01-18/23 :&nbsp;
                  <span style={{ color: ORANGE }}>100,00 % </span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ACTION SEMC : &nbsp;
                  <span style={{ color: ORANGE }}> 47000 FCFA </span> (0,000
                  %)&nbsp;
                </b>
              </div>
            </div>
          </div>
        </Container>
      )}
      <div style={{ margin: 'auto' }}>{children}</div>
    </div>
  );
};
